import { inject } from '@angular/core';
import { selectPublicInit } from '@app/features/public/public.selectors';
import { Store } from '@ngrx/store';
import { first } from 'rxjs';
import { PublicActions } from 'src/app/features/public/public.actions';

export const publicStateInitializer = () => {
  const store = inject(Store);

  return new Promise<void>((resolve) => {
    store.dispatch(PublicActions.initStart());

    store
      .select(selectPublicInit)
      .pipe(first(Boolean))
      .subscribe(() => resolve());
  });
};
